$(function(){
    $('#main_filter_show').click(function() {
        $('.main-filters-block__content').toggleClass('main-filters-block__content--show')
        $('.main-filters-block__btn').toggleClass('main-filters-block__btn--hide')
    })
})